import { FetchResponse, AppError } from 'models';

class Mapper {
  static mapSuccesResponse<T>(response: T): FetchResponse<T> {
    const result: FetchResponse<T> = {
      type: 'success',
      data: response,
    };
    return result;
  }

  static mapError<T>(error: any): FetchResponse<T> {
    const errorObject: AppError = {
      code: error.code,
      message: error.message,
    };
    const result: FetchResponse<T> = {
      type: 'error',
      error: errorObject,
    };
    return result;
  }
}

export default Mapper;
